import TrackingQueue from '../components/containers/tracking-queue';
import LoadDetails from '../components/containers/load-details';
import LoginRedirect from '../components/containers/login-redirect';
import OidcCallbackHandler from '../components/containers/oidc-callback-handler';
import ProfileSettings from '../components/containers/profile-settings';

const routes = [
  {
    component: TrackingQueue,
    exact: true,
    path: '/',
    id: 0,
  },
  {
    component: LoadDetails,
    exact: true,
    path: '/loads/detail/:id',
    id: 1,
  },
  {
    component: ProfileSettings,
    exact: true,
    path: '/profilesettings',
    id: 2,
  },
];

export const unauthenticatedRoutes = [
  {
    component: OidcCallbackHandler,
    exact: false,
    path: '/callback',
    id: 3,
  },
  {
    component: LoginRedirect,
    exact: true,
    path: '*',
    id: 4,
  },
];

export default routes;
